import { EData } from "../interfaces/enum";
import { DataType } from "../interfaces/types";
import data from "../data";

export const getData = (value: EData): DataType => {
  return data[value as keyof typeof data];
};

export type Account = {
  email: string;
  password: string;
};

export const getAccounts = async (): Promise<Account[]> => {
  try {
    const prom = await fetch("http://localhost:8800/accounts");
    const response: Account[] = await prom.json();
    return new Promise((res) => {
      res(response);
    });
  } catch (er) {
    return new Promise((res) => {
      res(getData(EData.ACCOUNTS) as Account[]);
    });
  }
};
